module.exports = __webpack_public_path__ + "static/img/dj_yx.083ee164.png";